const originUrl = process.env.NODE_ENV === 'development' ? 'https://www.custcome.com' : top.location.origin
export const homeApp = process.env.PATH_ENV === 'test' ? {
  NLoginUrl: originUrl + '/static/mc/showcase/#/nhome', // 测试环境 https://www.quncion.com
  calendarUrl: originUrl + '/wonkerlab/marketing_calendar_backend', //  日历测试环境
  homePage: originUrl + '/testxcx/a/login', //  测试环境
  dashbordUrl: originUrl + '/static/mc/dashboard', // dashbord 路径
  baseUrl: originUrl + '/wonkerlab/mc', //  测试环境
  control: '/dashboard/#/console', // 控制台首页路径
  userCenter: '/dashboard/#/center', // 控制台用户中心路径
  orderComplete: '/dashboard/#/order/complete', // 已完成订单
  officialWebsite: 'https://www.custcome.com',
  formalEnv: false // 是否正式环境
} : {
  NLoginUrl: originUrl + '/hk/#/nhome', // 新的统一登录页，待定  //  替换最新登录页
  calendarUrl: originUrl + '/marketing_calendar_backend', // 正式环境
  homePage: originUrl + '/xcxnetcom_appmanager/a/login', // 线上环境
  dashbordUrl: originUrl + '/hk/dashboard', // dashbord 路径
  baseUrl: originUrl,
  control: '/hk/dashboard/#/console', // 控制台首页路径
  userCenter: '/hk/dashboard/#/center', // 控制台用户中心路径
  orderComplete: '/hk/dashboard/#/order/complete', // 已完成订单
  officialWebsite: 'https://www.custcome.com/',
  formalEnv: true
}

export const calendarApp = {
  baseUrl: originUrl + '/hk/calendar/', // 正式环境
  template: '#/template/'
}



// WEBPACK FOOTER //
// ./src/config/index.js